import createApiClient from "./api";

const api = createApiClient();

/**
 * @param {string} text
 * @param {{ signal?: AbortSignal }} [options]
 */
export const enhanceText = async (text, options = {}) => {
  const { signal } = options;
  const { data } = await api.post("/ai/enhance-text", { text }, { signal });
  return data;
};

/**
 * Product help chatbot (docs context pack). The response's `file_ids` are the
 * chat files still in use; files attached to a created record, deleted or
 * expired are left out, so the caller drops them.
 * @param {string} message
 * @param {{ history?: Array<{ role: 'user' | 'assistant', content: string }>, projectId?: string, page?: string, fileIds?: string[], signal?: AbortSignal }} [options]
 */
export const askHelpChat = async (message, options = {}) => {
  const { history = [], signal, projectId, page, fileIds = [] } = options;
  const { data } = await api.post(
    "/ai/help-chat",
    {
      message,
      history,
      ...(projectId ? { project_id: projectId } : {}),
      ...(page ? { page } : {}),
      ...(fileIds.length ? { file_ids: fileIds } : {}),
    },
    { signal }
  );
  return data;
};

/**
 * Files for the help chat. The API deletes them after 24 hours unless they
 * are attached to an RFI or submittal.
 * @param {string} projectId
 * @param {FormData} formData
 */
export const uploadHelpChatFiles = async (projectId, formData) => {
  const { data } = await api.post("/ai/help-chat/files", formData, {
    params: { project_id: projectId },
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

/**
 * Help chat answer as a PDF. The API streams the file; nothing is stored.
 * @param {string} title
 * @param {string} markdown
 * @returns {Promise<Blob>}
 */
export const downloadHelpChatPdf = async (title, markdown) => {
  const { data } = await api.post(
    "/ai/help-chat/pdf",
    { title, markdown },
    { responseType: "blob" }
  );
  return data;
};
